type LangsType = {
  label: string;
  key: string;
  abbreviationKey: string;
  icon?: string;
};

const langsConfig: LangsType[] = [
  {
    label: 'English',
    key: 'en-US',
    abbreviationKey: 'en',
  },
  {
    label: 'Français',
    key: 'fr-FR',
    abbreviationKey: 'fr',
  },
  {
    label: 'Português',
    key: 'pt-PT',
    abbreviationKey: 'pt',
  },
  {
    label: 'Deutschland',
    key: 'de-DE',
    abbreviationKey: 'de',
  },
  {
    label: 'Italia',
    key: 'it-IT',
    abbreviationKey: 'it',
  },
  {
    label: 'España',
    key: 'es-ES',
    abbreviationKey: 'es',
  },
];

const getLangsConfig = (): LangsType[] => {
  return langsConfig.map((items) => {
    return {
      ...items,
      icon: `${process.env.REACT_APP_PREFIX_HOST}/img/icon/${items.abbreviationKey}.svg`,
    };
  });
};

const langs = getLangsConfig();

export { langs };
